'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toProperties = exports.linearStateFromNewProps = exports.initialState = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _constants = require('../constants');

var _utils = require('./utils');

var _stacked = require('./stacked');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasXLinear = function hasXLinear(type) {
  return R.includes(type, [_constants.H_SYMBOL, _constants.ROW, _constants.SCATTER, _constants.STACKED_ROW]);
};

var hasYLinear = function hasYLinear(type) {
  return R.includes(type, [_constants.BAR, _constants.SCATTER, _constants.STACKED_BAR, _constants.TIMELINE, _constants.V_SYMBOL]);
};

var hasXPivot = function hasXPivot(type) {
  return R.equals(_constants.ROW, type);
};
var hasYPivot = function hasYPivot(type) {
  return R.equals(_constants.BAR, type);
};

var xInitialState = {
  computedMaxX: undefined,
  computedMinX: undefined,
  computedStepX: undefined,
  computedPivotX: undefined,
  maxX: undefined,
  minX: undefined,
  pivotX: undefined,
  stepX: undefined
};

var yInitialState = {
  computedMaxY: undefined,
  computedMinY: undefined,
  computedStepY: undefined,
  computedPivotY: undefined,
  maxY: undefined,
  minY: undefined,
  pivotY: undefined,
  stepY: undefined
};

var initialState = exports.initialState = (0, _extends3.default)({}, xInitialState, yInitialState);

var linearStateFromNewProps = exports.linearStateFromNewProps = function linearStateFromNewProps(type) {
  var xLinearState = hasXLinear(type) ? {} : xInitialState;
  var YLinearState = hasYLinear(type) ? {} : yInitialState;
  return (0, _extends3.default)({}, xLinearState, R.when(R.always((0, _stacked.isStacked)(type)), R.assoc('pivotY', 0))(YLinearState));
};

var toProperties = exports.toProperties = function toProperties(props, state, _onChange) {
  return {
    maxX: {
      id: 'maxX',
      isActive: hasXLinear(props.type),
      onChange: function onChange(value) {
        return _onChange({
          maxX: (0, _utils.isNumber)(value) ? value : undefined
        });
      },
      value: R.isNil(state.maxX) ? String(state.computedMaxX) : state.maxX
    },
    maxY: {
      id: 'maxY',
      isActive: hasYLinear(props.type),
      onChange: function onChange(value) {
        return _onChange({
          maxY: (0, _utils.isNumber)(value) ? value : undefined
        });
      },
      value: R.isNil(state.maxY) ? String(state.computedMaxY) : state.maxY
    },
    minX: {
      id: 'minX',
      isActive: hasXLinear(props.type),
      onChange: function onChange(value) {
        return _onChange({
          minX: (0, _utils.isNumber)(value) ? value : undefined
        });
      },
      value: R.isNil(state.minX) ? String(state.computedMinX) : state.minX
    },
    minY: {
      id: 'minY',
      isActive: hasYLinear(props.type),
      onChange: function onChange(value) {
        return _onChange({
          minY: (0, _utils.isNumber)(value) ? value : undefined
        });
      },
      value: R.isNil(state.minY) ? String(state.computedMinY) : state.minY
    },
    pivotX: {
      id: 'pivotX',
      isActive: hasXPivot(props.type),
      onChange: function onChange(value) {
        return _onChange({
          pivotX: (0, _utils.isNumber)(value) ? value : undefined
        });
      },
      value: R.when(function (v) {
        return R.isNil(v) && (R.propEq('type', _constants.ROW)(props) || R.propEq('type', _constants.STACKED_ROW)(props));
      }, R.always(0))(R.isNil(state.pivotX) ? String(state.computedPivotX) : state.pivotX)
    },
    pivotY: {
      id: 'pivotY',
      isActive: hasYPivot(props.type),
      onChange: function onChange(value) {
        return _onChange({
          pivotY: (0, _utils.isNumber)(value) ? value : undefined
        });
      },
      value: R.when(function (v) {
        return R.isNil(v) && (R.propEq('type', _constants.BAR)(props) || R.propEq('type', _constants.STACKED_BAR)(props));
      }, R.always(0))(R.isNil(state.pivotY) ? String(state.computedPivotY) : state.pivotY)
    },
    stepX: {
      id: 'stepX',
      isActive: hasXLinear(props.type),
      onChange: function onChange(value) {
        return _onChange({
          stepX: (0, _utils.isPositiveNumber)(value) ? value : undefined
        });
      },
      value: R.isNil(state.stepX) ? String(state.computedStepX) : state.stepX
    },
    stepY: {
      id: 'stepY',
      isActive: hasYLinear(props.type),
      onChange: function onChange(value) {
        return _onChange({
          stepY: (0, _utils.isPositiveNumber)(value) ? value : undefined
        });
      },
      value: R.isNil(state.stepY) ? String(state.computedStepY) : state.stepY
    }
  };
};